
import {API_ADMIN_MONGO} from 'consts/api'

export default {
  props: {
    coll_name: {type: String, required: true}
  },
  computed: {
    api_url() {
      return `${API_ADMIN_MONGO}/collections/${this.coll_name}`
    }
  },
  methods: {
    uuidHexToBase64(hex) {
      // Remove hyphens from the UUID string
      const hexNoHyphens = hex.replace(/-/g, '')
      
      // Convert the hex string to a binary string
      let binaryString = ''
      for (let i = 0; i < hexNoHyphens.length; i += 2) {
        binaryString += String.fromCharCode(parseInt(hexNoHyphens.substr(i, 2), 16))
      }

      // Use btoa() to base64-encode the binary string
      return btoa(binaryString)
    },
    formatFilter(filter) {
      // Ensure the string is wrapped in braces if it's not already.
      if (!(filter.startsWith('{') && filter.endsWith('}'))) {
        filter = `{${filter}}`
      }

      // Convert UUID('...') or UUID("...") to MongoDB's Extended JSON
      filter = filter.replace(/UUID\((['"])(.*?)\1\)/g, (match, quote, uuid) => {
        const base64Uuid = this.uuidHexToBase64(uuid)
        return `{"$binary": {"base64": "${base64Uuid}", "subType": "04"}}`
      })

      // Find word characters followed by a colon (unquoted keys) and wrap the key in double quotes.
      // For example: {type: 'news'} becomes {"type": 'news'}
      filter = filter.replace(/([{\s,])([a-zA-Z0-9_$]+)\s*:/g, '$1"$2":')

      // Replace all remaining single quotes with double quotes to handle string values.
      // For example: {"type": 'news'} becomes {"type": "news"}
      filter = filter.replace(/'/g, '"')

      // Validate
      JSON.parse(filter)

      return filter
    }
  }
}
